import React, { useEffect, useState } from 'react';
import { AppstoreFilled, FolderFilled, SyncOutlined } from '@ant-design/icons';
import { Popover, Radio, Select, Space } from 'antd';
import { channels } from './constants';
import DateRangePicker from 'app/components/shared/app/DateRangePicker';
import CustomMultiSelectDropdown from 'app/components/shared/app/CustomMultiSelectDropdown';
import adsIcon from '../../../../../static/icons/ads.svg';
import filterIcon from '../../../../../static/icons/filter.svg';
import adayaIcon from '../../../../../static/icons/hub/blended.svg';
import { allMetricOptions, allPerformanceOptions, highLowPerformanceOptions } from './config';

// const { RangePicker } = DatePicker;
const { Option } = Select;

const RefreshButton = ({ onRefresh, isLoading }) => {
    return (
        <SyncOutlined
            onClick={() => {
                if (!isLoading) {
                    onRefresh();
                }
            }}
            style={{ color: '#337AED', stroke: '#337AED', fontSize: '25px', strokeWidth: '30' }}
            spin={isLoading}
        />
    );
};

const CustomAdsSelect = ({ activeTab, setActiveTab }) => {
    const handleChange = (e) => {
        setActiveTab(e.target.value);
    };

    return (
        <div className="type-box">
            <Radio.Group className="custom-radio-group" value={activeTab} onChange={handleChange} buttonStyle="solid">
                <Radio.Button className="custom-radio-item campaigns-radio" value="campaigns">
                    <FolderFilled /> Campaigns
                </Radio.Button>
                <Radio.Button className="custom-radio-item adsets-radio" value="adsets">
                    <AppstoreFilled /> Adsets
                </Radio.Button>
                <Radio.Button className="custom-radio-item ads-radio" value="ads">
                    <img src={adsIcon} width="15" height="15" style={{ marginTop: '-2px', marginRight: '5px' }} alt="ads icon" /> Ads
                </Radio.Button>
            </Radio.Group>
        </div>
    );
};

const CustomFilter = ({ dateRange, setDateRange, metricOption, setMetricOption, performanceOption, setPerformanceOption, selChannels, setSelChannels }) => {
    const [visible, setVisible] = useState(false);
    const [open, setOpen] = useState(false);

    const handleVisibleChange = (newVisible) => {
        setVisible(newVisible);
    };

    const handleMetricChange = (value) => {
        setMetricOption(value);
        setPerformanceOption('Highest');
    };

    const handlePerformanceChange = (value) => {
        setPerformanceOption(value);
    };

    const handleChannelChange = (options) => {
        setSelChannels(options);
    };

    const filterPopup = () => {
        return (
            <div id="filter-popup">
                <div style={{ width: '300px', marginBottom: '8px' }}>
                    <CustomMultiSelectDropdown
                        placeholder="Select Channel"
                        select={selChannels}
                        options={channels}
                        allOption={{
                            label: 'All Channels',
                            value: 'all',
                            icon: <img src={adayaIcon} width="24" height="24" />
                        }}
                        onChange={handleChannelChange}
                    />
                </div>
                <Space direction="horizontal" size={12}>
                    <Select className="custom-select" value={metricOption} style={{ width: 150 }} onChange={handleMetricChange}>
                        {allMetricOptions.map((item) => (
                            <Option key={item.value} value={item.value} disabled={item.disabled}>
                                {item.label}
                            </Option>
                        ))}
                    </Select>
                    is
                    <Select className="custom-select" value={performanceOption} style={{ width: 150 }} onChange={handlePerformanceChange}>
                        {(['Adspend', 'Revenue', 'Profit', 'Conv Rate', 'Orders'].includes(metricOption) ? highLowPerformanceOptions : allPerformanceOptions).map((item) => (
                            <Option key={item.value} value={item.value} disabled={item.disabled}>
                                {item.label}
                            </Option>
                        ))}
                    </Select>
                </Space>
                {/* <RangePicker
                    className="custom-date-range"
                    separator={<MinusOutlined />}
                    value={dateRangeListSelect.dates}
                    open={open}
                    onChange={e => {
                        handleDateRange(e);
                    }}
                    onOpenChange={isOpen => isOpen && setOpen(isOpen)}
                    format={'LL'}
                    renderExtraFooter={DatePickerExtraFooter}
                    suffixIcon={<img src={icon} className={`date-range-picker`} />}
                /> */}
                <DateRangePicker dateRange={dateRange} onSetDateRange={(r) => setDateRange(r.dates)} />
            </div>
        );
    };

    return (
        <div className="filter">
            <Popover content={filterPopup()} placement="bottom" trigger="click" visible={visible} onVisibleChange={handleVisibleChange}>
                <div className="filter-pin">
                    <img src={filterIcon} width="14" height="14" style={{ marginTop: '3px', marginRight: '5px' }} alt="filter icon" />
                    Filter
                </div>
            </Popover>

            <div className="filter-options">
                <div style={{ width: '250px', marginRight: '50px' }}>
                    <CustomMultiSelectDropdown
                        placeholder="Select Channel"
                        select={selChannels}
                        options={channels}
                        allOption={{
                            label: 'All Channels',
                            value: 'all',
                            icon: <img src={adayaIcon} width="24" height="24" />
                        }}
                        onChange={handleChannelChange}
                    />
                </div>
                <Space className="general-filter" direction="horizontal" size={12}>
                    <Select className="custom-select" value={metricOption} style={{ width: 150 }} onChange={handleMetricChange}>
                        {allMetricOptions.map((item) => (
                            <Option key={item.value} value={item.value} disabled={item.disabled}>
                                {item.label}
                            </Option>
                        ))}
                    </Select>
                    is
                    <Select className="custom-select" value={performanceOption} style={{ width: 150 }} onChange={handlePerformanceChange}>
                        {(['Adspend', 'Revenue', 'Profit', 'Conv Rate', 'Orders'].includes(metricOption) ? highLowPerformanceOptions : allPerformanceOptions).map((item) => (
                            <Option key={item.value} value={item.value} disabled={item.disabled}>
                                {item.label}
                            </Option>
                        ))}
                    </Select>
                    for
                    {/* <RangePicker
                        className="custom-date-range"
                        separator={<MinusOutlined />}
                        value={dateRangeListSelect.dates}
                        open={open}
                        onChange={e => {
                            handleDateRange(e);
                        }}
                        onOpenChange={isOpen => isOpen && setOpen(isOpen)}
                        format={'LL'}
                        renderExtraFooter={DatePickerExtraFooter}
                        suffixIcon={<img src={icon} className={`date-range-picker`} />}
                    /> */}
                    <DateRangePicker dateRange={dateRange} onSetDateRange={(r) => setDateRange(r.dates)} />
                </Space>
            </div>
        </div>
    );
};

const AdsManagerHeader = ({ activeTab, setActiveTab, dateRange, setDateRange, onRefresh, isLoading, metricOption, setMetricOption, performanceOption, setPerformanceOption, selChannels, setSelChannels }) => {
    return (
        <div className="ads-manager-header">
            <div className="title">
                <h1>Ads Manager</h1>
            </div>
            <div className="refresh">
                Updated just now
                <RefreshButton onRefresh={onRefresh} isLoading={isLoading} />
            </div>
            <div className="options">
                <CustomFilter
                    dateRange={dateRange}
                    setDateRange={setDateRange}
                    metricOption={metricOption}
                    setMetricOption={setMetricOption}
                    performanceOption={performanceOption}
                    setPerformanceOption={setPerformanceOption}
                    selChannels={selChannels}
                    setSelChannels={setSelChannels}
                />
                <CustomAdsSelect activeTab={activeTab} setActiveTab={setActiveTab} />
            </div>
        </div>
    );
};

export default AdsManagerHeader;
